"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

var _axios = _interopRequireDefault(require("axios"));

var cart = _interopRequireWildcard(require("@shopify/theme-cart"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("./utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-ajax-cart="container"]',
  addToCart: '[js-ajax-cart="addToCart"]',
  clearCart: '[js-ajax-cart="clearCart"]',
  remove: '[js-ajax-cart="remove"]',
  lineItem: '[js-ajax-cart="lineItem"]',
  form: '[js-ajax-cart="form"]',
  cartCounter: '[js-ajax-cart="cartCounter"]'
};
/**
 * Export a new AjaxCart instance
 * @param {object} config - Settings to apply across all Ajax calls to the cart.
 */

var _default = function _default(config) {
  /**
   * Node selectors.
   */
  var nodeSelectors = {
    addToCart: _toConsumableArray(document.querySelectorAll(selectors.addToCart)),
    cartCounter: document.querySelector(selectors.cartCounter),
    clearCart: _toConsumableArray(document.querySelectorAll(selectors.clearCart)),
    container: _toConsumableArray(document.querySelectorAll(selectors.container))
  };
  /**
  * Initialise component.
  */

  function init() {
    setListeners();
    setAddToCartEvents();
    setClearCartEvents();
    setRemoveEvents();
  }
  /**
   * Set listeners.
   */


  function setListeners() {
    /**
     * Reinitialise Ajax cart on call.
     */
    Frame.EventBus.listen(['AjaxCart:init', 'AjaxCart:reinit'], function () {
      setRemoveEvents();
    });
    /**
     * React to any item changes in the cart.
     */

    Frame.EventBus.listen(['AjaxCart:itemAdded', 'AjaxCart:itemRemoved', 'AjaxCart:itemUpdated', 'AjaxCart:cartCleared'], function (response) {
      updateCounter();

      if (response.item_count <= 0) {
        Frame.EventBus.emit('AjaxCart:cartEmpty', response);
      }
    });
    /**
     * Global helper function to add items to cart and trigger
     * responses and linked interactions.
     */

    Frame.EventBus.listen('AjaxCart:addItem', function (_ref) {
      var id = _ref.id,
          options = _ref.options;
      cart.addItem(id, options).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemAdded', response);
      })["catch"](function (error) {
        window.console.error(error);
        return error;
      });
    });
    Frame.EventBus.listen('AjaxCart:removeItem', function (key) {
      cart.removeItem(key).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      })["catch"](function (error) {
        window.console.error(error);
        return error;
      });
    });
  }
  /**
  * Set click events on buttons to post form data.
  */


  function setAddToCartEvents() {
    nodeSelectors.addToCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleAddToCart(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleAddToCart(event);
      });
    });
  }
  /**
   * Handle add to cart event and set loading state.
   * @param {object} event - Click and key down event.
   */


  function handleAddToCart(event) {
    if (isKeyDownEvent(event) && !isKeyPressIsEnter(event)) {
      return;
    }

    event.preventDefault();
    var target = event.currentTarget;
    setLoadingState(target);

    _axios["default"].post('/cart/add.js', (0, _utils.serialize)(target.closest('form'))).then(function (response) {
      Frame.EventBus.emit('AjaxCart:itemAdded', response);
      setDefaultState(target);
      executeCallback();
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      setDefaultState();
      return error;
    });
  }
  /**
  * Set remove item events.
  */


  function setRemoveEvents() {
    _toConsumableArray(document.querySelectorAll(selectors.remove)).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleRemoveEvent(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleRemoveEvent(event);
      });
    });
  }
  /**
   * Handle remove event.
   * @param {Event} event - Click/keydown event object.
   */


  function handleRemoveEvent(event) {
    event.preventDefault();

    if (isKeyDownEvent(event) && !isKeyPressIsEnter(event)) {
      return;
    }

    Frame.EventBus.emit('AjaxCart:removingItem', event.currentTarget.closest(selectors.lineItem));
    event.preventDefault();
    cart.removeItem(event.currentTarget.dataset.key).then(function (response) {
      Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Check if key down event.
   * @param {Event} event - Keydown event object.
   */


  function isKeyDownEvent(event) {
    return event.type === 'keydown';
  }
  /**
   * Check if the return key is pressed.
   * @param {Event} event - Key code event.
   */


  function isKeyPressIsEnter(event) {
    return event.which === 13;
  }
  /**
   * Set clear cart events if enabled.
   */


  function setClearCartEvents() {
    if (!nodeSelectors.clearCart) {
      return;
    }

    nodeSelectors.clearCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return clearItems(event);
      });
    });
  }
  /**
   * Handle clear cart events.
   * @param {Event} event - Click/keydown event object.
   */


  function clearItems(event) {
    event.preventDefault();
    cart.clearItems().then(function (response) {
      Frame.EventBus.emit('AjaxCart:cartCleared', response);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Update cart counter.
   */


  function updateCounter() {
    _axios["default"].get('/cart.js').then(function (response) {
      renderCartCounter(response.data);
      return response.data.item_count;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Render cart counter.
   * @param {Object} response - Cart.json data.
   */


  function renderCartCounter(response) {
    nodeSelectors.cartCounter.classList.remove(_cssClasses["default"].hidden);
    nodeSelectors.cartCounter.innerText = response.item_count;

    if (response.item_count <= 0) {
      nodeSelectors.cartCounter.classList.add(_cssClasses["default"].hidden);
    }
  }
  /**
   * Set loading state.
   * @param {object} target clicked add to cart button in DOM.
   */


  function setLoadingState(target) {
    _toConsumableArray(nodeSelectors.addToCart).forEach(function (element) {
      if (target === element) {
        element.innerText = theme.strings.addingToCart;
      }
    });
  }
  /**
  * Reset the loading states back to default.
  * @param {object} target clicked add to cart button in DOM.
  */


  function setDefaultState(target) {
    _toConsumableArray(nodeSelectors.addToCart).forEach(function (element) {
      if (target === element) {
        if (target.getAttribute('data-preorder')) {
          element.innerText = theme.strings.preOrder;
        } else {
          element.innerText = theme.strings.addToCart;
        }
      }
    });
  }
  /**
   * Execute callback function defined in constructor.
   */


  function executeCallback() {
    return _typeof(config) === 'object' && config.callback === 'function' ? config.callback() : false;
  }
  /**
   * Public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;